import { DatepickerSelection } from './datepicker-selection';
import { DatepickerValidation } from './datepicker-validation';
export class DatepickerMonthlyAdapter {
    constructor(calendar) {
        this.calendar = calendar;
        this.calendar = calendar;
    }
    selectDate(month) {
        if (!this.canBeSelected(month)) {
            return;
        }
        this.calendar.setMonth(month);
        this.calendar.selectDate(this.calendar.getDay());
    }
    decreaseYear() {
        this.calendar.setYear(this.calendar.getYear() - 1);
    }
    increaseYear() {
        this.calendar.setYear(this.calendar.getYear() + 1);
    }
    isMonthSelected(month) {
        if (this.calendar.getSelection() === DatepickerSelection.FROM) {
            if (this.calendar.getSelectedDate() && this.calendar.getSelectedDate().getMonth() === month && this.calendar.getYear() === this.calendar.getSelectedDate().getFullYear()) {
                return true;
            }
        }
        if (this.calendar.getSelection() === DatepickerSelection.TO) {
            if (this.calendar.getSelectedDateTo() && this.calendar.getSelectedDateTo().getMonth() === month && this.calendar.getYear() === this.calendar.getSelectedDateTo().getFullYear()) {
                return true;
            }
        }
        if (this.calendar.getSelection() === DatepickerSelection.NONE) {
            if (this.calendar.getDate() && this.calendar.getDate().getMonth() === month && this.calendar.getYear() === this.calendar.getDate().getFullYear()) {
                return true;
            }
        }
        return null;
    }
    getDate() {
        return this.calendar.getDate();
    }
    getDay() {
        return this.calendar.getDay();
    }
    getMonth() {
        return this.calendar.getMonth();
    }
    getYear() {
        return this.calendar.getYear();
    }
    canBeSelected(month) {
        const now = new Date();
        const time = new Date(this.calendar.getYear(), month, now.getDate());
        if (this.calendar.getValidation() === DatepickerValidation.NONE) {
            return true;
        }
        if (this.calendar.getValidation() === DatepickerValidation.PAST && now.getFullYear() === time.getFullYear() && time.getMonth() > now.getMonth()) {
            return false;
        }
        if (this.calendar.getValidation() === DatepickerValidation.FUTURE && now.getFullYear() === time.getFullYear() && time.getMonth() < now.getMonth()) {
            return false;
        }
        return true;
    }
}
